import React from 'react';

const PolicyPage = () => {
  const today = new Date().toLocaleDateString();

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <h2>Privacy Policy</h2>
      <p><strong>Effective Date:</strong> {today}</p>
      <p>At MySchedulePal, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your information.</p>

      <h4>1. Information We Collect</h4>
      <ul>
        <li>Personal Identifiable Information (PII): Name, email address, phone number, etc.</li>
        <li>Health Information (if applicable): Data related to scheduling medical appointments.</li>
        <li>Usage Data: Device information, IP address, and usage patterns.</li>
        <li>Saved Data: Any data saved, (such as contact infomration that you import) is secured on a database that is protected and encrypted. This data can be deleted and removed permanently by you at any time.</li>
      </ul>

      <h4>2. How We Use the Information</h4>
      <ul>
        <li>Provide and improve the Service.</li>
        <li>Ensure compliance with legal and regulatory standards.</li>
        <li>Communicate updates or changes to the Service.</li>
      </ul>

      <h4>3. Data Sharing</h4>
      <ul>
        <li>We do not sell your information.</li>
        <li>We may share data with service providers (e.g., cloud storage, payment processors).</li>
        <li>Authorized entities as required by law.</li>
        <li>We have agreements in place to protect Patient PHI, ensuring HIPAA Compliance.</li>
      </ul>

      <h4>4. Data Security</h4>
      <p>We employ robust security measures, including encryption and secure storage, to protect your data from unauthorized access. We also have a Business Associate Agreement with our 3rd-party API provider, ensuring privacy and HIPAA Compliance.</p>

      <h4>5. User Rights</h4>
      <ul>
        <li>Access and review their data.</li>
        <li>Request corrections or deletions.</li>
        <li>Opt out of non-essential data processing.</li>
      </ul>

      <h4>6. HIPAA Compliance</h4>
      <p>For users in the healthcare sector, we comply with HIPAA standards to protect PHI. Please avoid sharing sensitive health data through non-secure channels.</p>

      <p>If you have questions about this Privacy Policy, contact us at <a href="mailto:support@myschedulepal.com">support@myschedulepal.com</a>.</p>

      <h2 className='mt-4'>Terms of Service</h2>
      <p><strong>Effective Date:</strong> {today}</p>
      <p>Welcome to MySchedulePal! These Terms of Service ("Terms") govern your use of our services, including our mobile application and website (collectively, the "Service"). By using MySchedulePal, you agree to be bound by these Terms. Please read them carefully.</p>

      <h4>1. User Responsibilities</h4>
      <ul>
        <li>Do not misuse the Service (e.g., sharing accounts, using for unlawful purposes, disrupting service, or mishandling patient info).</li>
      </ul>

      <h4>2. Service Disclaimer</h4>
      <p>MySchedulePal is a tool for scheduling and time management—not a replacement for medical advice. Always consult professionals for health-related decisions.</p>

      <h4>3. Limitation of Liability</h4>
      <p>To the maximum extent permitted by law, MySchedulePal is not liable for damages from use or inability to use the Service.</p>

      <h4>4. HIPAA Disclaimer</h4>
      <p>We comply with HIPAA when handling PHI. You are responsible for avoiding unprotected sharing of PHI.</p>

      <h4>5. Governing Law</h4>
      <p>These Terms are governed by the laws of Your Jurisdiction. Disputes will be resolved in those courts.</p>

      <h4>6. Termination Clause</h4>
      <p>We may suspend or terminate accounts for violations of these Terms or other policies.</p>

      <p>If you have questions about these Terms, contact us at <a href="mailto:support@myschedulepal.com">support@myschedulepal.com</a>.</p>
    </div>
  );
};

export default PolicyPage;
